import Vue from "vue";
import App from "./App";
import router from "./router";
import "./assets/base.less";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/zh-CN";
locale.el.pagination.goto = "跳至";

Vue.use(ElementUI);

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  render: (h) => h(App),
});
